<template>
    <div class="ChargeDischarge">
        <Title firstName="充放电统计" lastName="CHARGE AND DISCHARGE STATISTICS"/>
        <div class="echarts">
            <div class="edata">
                <div class="edataCon">
                    <p>本月充电</p>
                    <p>{{total}}<span> kWh</span></p>
                </div>
                <div class="edataCon">
                    <p>本月放电</p>
                    <p>{{total}}<span> kWh</span></p>
                </div>
                <div class="sevenDay" >近七日充放电</div>
            </div>
            <div class="eview">
                <Bar :chartId="chartId" :seriesData="seriesData" :seriesData2="seriesData1" :xData="xData" v-if="xData.length > 0 && seriesData.length > 0"/>
            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
const Title = () => import('../../../components/title/Title.vue')
const Bar = () => import('../../../components/echarts/bar.vue')

import { getSevenDays } from '../../../utils/common'
export default {
    data(){
        return {
            chartId:'generAll',
            xData:[],
            seriesData:[0, 160, 160, 160, 160, 160, 160],
            seriesData1:[0, 160, 160, 160, 160, 160, 0]
        }
    },
    components:{
        Title,Bar
    },
    computed:{
        total(){
            let sum = 0
            this.seriesData.forEach(item =>{
                sum += item
            })
            return sum
        }
    },
    mounted(){
        this.getWeekDay()
    },
    methods:{
        getWeekDay(){
            let time = getSevenDays()
            let keys = Object.values(time)
            let week = keys.reverse().map(item =>{
                return item = item.substr(5)
            }) 
            this.xData = week
        }
    }
}
</script>

<style lang="less" scoped>
    .ChargeDischarge{
        height: 33.3vh;
        width: 20vw;
        position: fixed;
        top: 64.4vh;
        left: 2vw;

        .echarts{
            position: relative;
            height: 28.7vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);

            .edata{
                height: 9vh;
                display: flex;
                justify-content: space-around;
                padding: 3vh 0;
                .edataCon{
                    text-align: center;
                    p:nth-child(1){
                        font-size: 14rem;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: rgba(230,243,253, 0.7);
                    }
                    p:nth-child(2){
                        padding-top: 3rem;
                        font-size: 20rem;
                        font-family: zcoolqingkehuangyouti;
                        font-weight: 400;
                        color: #00DEFF;
                        span{
                            font-size: 14rem;
                        }
                    }
                }

                .sevenDay{
                    font-size: 12rem;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: rgba(230,243,253, 0.7);
                    position: absolute;
                    right: 1vw;
                    top: 8vh;
                }
            }

            .eview{
                width: 100%;
                padding: 0 0.5vw;
                height: 17.9vh;
                #chargeChart{
                    width: 100%;
                    height: 100%;
                }
            }

            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }

        
    }

</style>